export default "__VITE_ASSET__CFIsKfyL__"